import React from 'react';
import ReactDOM from 'react-dom/client';
import { Layout } from './Layout'
import { HashRouter } from "react-router-dom";
import './i18n'; //lang


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <Layout/>
    </HashRouter>
   
   {/* <RouterProvider router={router} /> */}
  </React.StrictMode>
);

